import { CONSULT_TYPE_CHAT } from 'Constants/consults';
import useCreateFollowUp from 'Hooks/teleconsult/useCreateFollowUp';
import { number, shape } from 'prop-types';
import React, { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'semantic-ui-react';
import useClinic from 'Containers/Home/hooks/useClinic';
import { useCurrentClinic } from 'Containers/Home/hooks/useCurrentClinic';
import useProfile from 'Hooks/doctor/useDoctorProfile';
import { findClinicIdFromClinicsMapping } from 'Helpers/consult-utils';

const FollowUpButton = ({ conversation, doctorId }) => {
  const statusConsult = useSelector(state => state.webChat.consults.status, shallowEqual);

  const { profile } = useProfile();

  const { createAFollowUp } = useCreateFollowUp();
  const { clinics } = useClinic(profile.id);
  const { currentClinicId } = useCurrentClinic();

  const startFollowUp = useCallback(async () => {
    const {
      latestConsult: {
        id,
        patient: { id: patientId },
        forPatient: { id: forPatientId },
      },
    } = conversation;

    // Find clinicId to create a follow-up
    // Check if clinic list contain the clinicId of the consult
    // Otherwise, use the current clinicId
    const consultClinicId = findClinicIdFromClinicsMapping(
      conversation?.latestConsult?.clinics || [],
      profile?.id,
    );

    const clinicId = (clinics || []).some(clinic => clinic.id === consultClinicId)
      ? consultClinicId
      : currentClinicId;

    const body = {
      patientId,
      forPatientId,
      extraData: {
        type: CONSULT_TYPE_CHAT,
        id,
      },
      clinicId,
    };

    await createAFollowUp(doctorId, body);
  }, [conversation, createAFollowUp, doctorId, clinics, currentClinicId]);

  const loading = statusConsult.create === 0;
  return (
    <Button
      fluid
      content="Start Follow-up Consult"
      onClick={startFollowUp}
      loading={loading}
      disabled={loading}
    />
  );
};

FollowUpButton.propTypes = {
  doctorId: number.isRequired,
  conversation: shape({}).isRequired,
};

export default FollowUpButton;
